import "./CurrentTurnMarker.css";

function CurrentTurnMarker() {
  return <div className="gg-chevron-right" />;
}

export default CurrentTurnMarker;
